import { caseService, docService, memberService, syncService } from "../_services"
// import moment from 'moment'
// moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    updating: false,
    predicate: null,
    currentPredicate: null,
    currentDocId: null,
    selectedMember: null,
    sessionIndex: 0,

    courtCase: null,

    channels: {
      status: status.INITIAL,
      list: []
    },

    memberStatuses: {
      status: status.INITIAL,
      list: []
    },

    docTemplates: {
      status: status.INITIAL,
      list: []
    }, 

    docsToSign: {
      status: status.INITIAL,
      list: []
    }, 

    docsGas: {
      status: status.INITIAL,
      list: []
    }

  },

  getters: {
    caseId ({ courtCase }) {
      return courtCase ? courtCase.id : null
    },
    caseNumber ({ courtCase }) {
      return courtCase ? courtCase.number : '...'
    },
    caseEssence ({ courtCase }) {
      return courtCase ? courtCase.essence : ''
    },
    caseLawArticle ({ courtCase }) {
      return courtCase ? courtCase.lawArticle : ''
    },
    caseDateOfReceipt ({ courtCase }) {
      return courtCase ? courtCase.createDate : null
    },
    caseDateOfProduction ({ courtCase }) {
      if (courtCase && courtCase.caseSessions && courtCase.caseSessions.length > 0) {
        let sessions = courtCase.caseSessions.filter(s => s.caseStatus.name === "ReferralJudge")
        if (sessions.length > 0) {
          sessions.sort((a, b) => a.eventDate.localeCompare(b.eventDate))
          return sessions[0].eventDate
        }
      }
      return null
    },

    //  .sort((a, b) => a.persona.name.localeCompare(b.persona.name)) 

    members ({ courtCase }) {
      return courtCase 
      ? courtCase.caseMembers
      .filter(item => item.active.name!=="Archive")
      .sort((a, b) => {
        let s1 = a.status.sort == -1 ? 999 : a.status.sort
        let s2 = b.status.sort == -1 ? 999 : b.status.sort
        if(s1 != s2) 
            return s1 - s2
        else 
            return a.persona.name.localeCompare(b.persona.name)
      }) 
      .map(m => {
        m.displayName = m.persona.personaType.name == 'UL' && m.persona.orgName ? m.persona.orgName : m.persona.name
        return m
      })
      : []
    },

    sessions ({ courtCase }) {
      return courtCase && courtCase.caseSessions ? courtCase.caseSessions.sort((a, b) => b.createDate.localeCompare(a.createDate) || b.name.localeCompare(a.name)) : []
    },

    currentDoc ({ courtCase, currentDocId}) { 
      return courtCase ? courtCase.caseSessions.reduce((res, current) => {
        res.push(...current.sessionDocs)
        return res
      }, []).find(d => d.id == currentDocId) : null
    },

    currentSession (state, getters) {
      return getters.sessions.length > 0 ? getters.sessions[state.sessionIndex] : {}
    },

    isActiveSession (state, getters) {
      return getters.sessions.length == 0 ? false : state.sessionIndex == 0 ? true : false    
    },

    sessionDocs (state, getters) {
      return getters.currentSession.sessionDocs || []
    },

    documents ({ predicate, selectedMember }, getters) {
      let list = getters.sessionDocs
      if (selectedMember) {
        list = list.filter(d => selectedMember.id == d.sendable.memberId)
      }
      if (predicate) {
        list = list.filter(predicate)
      }
      return list.sort((a, b) => b.id - a.id)
    },

    channels ({ channels }) {
      return channels.list
    },

    memberStatuses ( {courtCase, memberStatuses }) {
      let list = memberStatuses.list
      if (courtCase && courtCase.gasTableType) {
        if (courtCase.gasTableType.name === 'G1_CASE')
          list = list.filter(sts => sts.value.toString().substr(0,4).indexOf("5071") != -1)  // 5071 - словарь гр. + фдм. видов лиц
        else if (courtCase.gasTableType.name === 'M_CASE' || courtCase.gasTableType.name === 'U1_CASE')
          if (courtCase.number.substr(0,3).indexOf("13-") != -1)
            list = list.filter(sts => sts.value.toString().substr(0,5).indexOf("5071") != -1) 
          else 
            list = list.filter(sts => sts.value.toString().substr(0,5).indexOf("91024") != -1) // 91024 - словарь уголовных видов лиц
        }
      
      let statusesPart1 = list.filter(sts => sts.sort > 0).sort((a, b) => a.sort - b.sort)
      let statusesPart2 = list.filter(sts => sts.sort == -1).sort((a, b) => a.title.localeCompare(b.title))
      return [...statusesPart1, ...statusesPart2]
      // return memberStatuses.list
    },

    docTemplates ({ docTemplates }) {
      return docTemplates.list
    },

    docsGas ({ docsGas }) {
      return docsGas.list
    },

    docsToSign ({ docsToSign}) {
      return docsToSign.list
    },

    subpoena ({ docTemplates }) {
      return docTemplates.list.find(x => x.walias === 'povestka') || { name: '', id: null }
    },

    docTemplateTags ({ docTemplates }) {
      let s = new Set()
      docTemplates.list
      .filter(item => item.tagged && item.tagged.length > 0)
      .map(item => {
        // item.tagged.map(x => x.myTag)
        item.tagged.map(x => s.add(x.myTag))
      })
      // .forEach(element => {
      //   console.log(element)
      //   s.add(...element)
      // })
      return [...s]
      // return [ ...new Set( ...docTemplates.list.map(item => [...item.tagged.map(x => x.myTag)] ))]
    }
  },

  mutations: {
    setUpdating: (state, value) => {
      state.updating = value
    },

    setPredicate: (state, value) => {
      state.predicate = value
      if (value == null) {
        state.selectedMember = null  
      }
    },
    
    setCurrentPredicate: (state, value) => {
      state.currentPredicate = value
    },

    setCurrentDocId: (state, value) => {
      state.currentDocId = value
    },

    setSelectedMember: (state, value) => {
      state.selectedMember = value
    },
    
    setSessionIndex: (state, index) => {
      state.sessionIndex = index
    },

    setCourtCase: (state, payload) => {
      if (state.courtCase && payload && state.courtCase.id != payload.id) {
        state.sessionIndex = 0
        state.predicate = null
      }
      state.courtCase = payload
    },


    setChannelsStatus: ({ channels }, status) => {
      channels.status = status
    },

    setChannels: ({ channels }, payload) => {
      channels.list = payload
    },


    setMemberStatusesStatus: ({ memberStatuses }, status) => {
      memberStatuses.status = status
    },

    setMemberStatuses: ({ memberStatuses }, payload) => {
      memberStatuses.list = payload
    },

    setDocTemplatesStatus: ({ docTemplates }, status) => {
      docTemplates.status = status
    },

    setDocTemplates: ({ docTemplates }, payload) => {
      docTemplates.list = payload
    },

    setDocsGas: ({ docsGas }, payload) => {
      docsGas.list = payload
    },

    setDocsToSign: ({ docsToSign }, payload) => {
      docsToSign.list = payload
    },
  },


  actions: {
    // INIT
    INIT: ({ dispatch }, { caseId }) => {
      dispatch('LOAD_CASE', caseId)
      dispatch('LOAD_CHANNELS')
      dispatch('LOAD_MEMBER_STATUSES')
      dispatch('LOAD_DOC_TEMPLATES')
      dispatch('LOAD_DOCS_GAS', caseId)
    },

    MEMBER_INIT: ({ dispatch, getters }, { caseId }) => {
      if (getters.caseId != caseId) {
        dispatch('LOAD_CASE', caseId)
        dispatch('LOAD_CHANNELS')
        dispatch('LOAD_MEMBER_STATUSES')
        dispatch('LOAD_DOC_TEMPLATES')
        dispatch('LOAD_DOCS_GAS', caseId)
      }
    },

    DOC_INIT: ({ dispatch, getters, commit }, { caseId, docId }) => {
      if (getters.caseId != caseId) {
        dispatch('LOAD_CASE', caseId)
      }
      commit('setCurrentDocId', docId)
    },

    LOAD_CASE: ({ state, commit }, caseId) => {
      commit('setUpdating', true)
      if (state.caseId != caseId) {
        commit('setCourtCase', null)
      }
      caseService.show(caseId)
      .then(data => {
        commit('setCourtCase', data)
        commit('setUpdating', false)
      })
    },

    LOAD_CHANNELS: ({ state, commit }) => {
      if (state.channels.status == status.INITIAL) {
        commit('setChannelsStatus', status.LOADING)
        caseService.sendChannels()
        .then(data => {
          commit('setChannels', data)
          commit('setChannelsStatus', status.LOADED)
        })  
      }
    },

    LOAD_MEMBER_STATUSES: ({ state, commit }) => {
      if (state.memberStatuses.status == status.INITIAL) {
        commit('setMemberStatusesStatus', status.LOADING)
        memberService.statuses()
        .then(data => {
          commit('setMemberStatuses', data)
          commit('setMemberStatusesStatus', status.LOADED)
        })  
      }
    },

    LOAD_DOC_TEMPLATES: ({ commit }) => {
      docService.templates().then(data => {
        commit('setDocTemplates', data)
      })  
    },

    LOAD_DOCS_GAS: ({ commit }, caseId) => {
      syncService.syncDocs(caseId).then(data => {
        commit('setDocsGas', data)
      })
    },

    LOAD_DOCS_TO_SIGN: ({ commit }) => {
      docService.listToSign().then(data => {
        commit('setDocsToSign', data)
      })  
    },

    // Documents

    sendVisibleDocuments: ({ getters, dispatch }) => {
      let list = getters.documents.map(obj => obj.id)
      docService.sendAll(list).then(() => dispatch('LOAD_CASE', getters.caseId))
    },

    deleteVisibleDocuments: ({ getters, dispatch }) => {
      let list = getters.documents.map(obj => obj.id)
      docService.deleteAll(list)
      .then(() => dispatch('LOAD_CASE', getters.caseId))
    },

    createDocument ({ getters, dispatch }, { caseMembers, docTemplateId = null, name, fileName = '' }) {
      memberService.personaAlerts({
        "caseSessionId": getters.currentSession.id, caseMembers, docTemplateId, name, fileName
      })
      .then(() => dispatch('LOAD_CASE', getters.caseId))
      .catch(e => console.log(e))
    },

    createSubpoena ({ getters, dispatch }, members) {
      dispatch('createDocument', { caseMembers: members, docTemplateId: getters.subpoena.id, name: getters.subpoena.name })
    },

    createDocumentByTemplate ({ dispatch }, { members, template, name }) {
      dispatch('createDocument', { caseMembers: members, docTemplateId: template.id, name })
    },

    createDocumentFromLocalFile ({ dispatch }, { members, name, file }) {
      dispatch('createDocument', { caseMembers: members, name, fileName: file })
    },

    // Channel 
    updateChannel: ({ dispatch, getters }, { document, channel }) => {
      docService.changeChannel(document.id, channel)
      .then(() => dispatch('LOAD_CASE', getters.caseId))
    }
  }
}